module.exports = __webpack_public_path__ + "img/beam.c9ff4469.svg";